export default {"src":"/_next/static/media/chat-icon.5fc8f692.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};